/* eslint-disable indent */
import React, { useState, useEffect, useRef } from "react";
import { Spin, Input, Row, Col, Form, message, Button, Table } from "antd";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { getProfileDetails } from "../../../actionsMethods/masterMethods";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import { DropDownComponent } from "../../Master/CommonComponents";
import NormalAPI from "../../../api";
import urls from "../../../api/urls";
import { getUserAndPremiseId } from "../../../utils";
import "./style.scss";

const auditOptions = [
    { value: "MODE", label: "MODE" },
    { value: "PINCODE", label: "PINCODE" }
];

const modeOptions = [
    { value: "surface", label: "SURFACE" },
    { value: "air", label: "AIR", disabled: true }
];

const BulkAudit = ({ activeKey, tabKey }) => {
    const dispatch = useDispatch();
    const inputRef = useRef(null);
    const [form] = Form.useForm();
    const [auditType, setAuditType] = useState(undefined);
    const [selectedMode, setSelectedMode] = useState("surface");
    const [inputValue, setInputValue] = useState("");
    const [pincode, setPincode] = useState("");
    const [loading, setLoading] = useState(false);
    const [auditResults, setAuditResults] = useState([]);

    useEffect(() => {
        if (activeKey === tabKey) {
            form.resetFields();
            setAuditType(undefined);
            setSelectedMode("surface");
            setInputValue("");
            setPincode("");
            setLoading(false);
            setAuditResults([]);
        }
    }, [activeKey, tabKey, form]);

    const profileDetails = useSelector(
        (state) => state.masterReducer.getProfileDetailsReducer,
        shallowEqual
    );
    const { fetching: loader } = profileDetails;

    useEffect(() => {
        const userinfo = JSON.parse(localStorage.getItem("userinfo"));
        console.log("Token:", userinfo?.accessToken);
        if (userinfo && userinfo.username) {
            dispatch(getProfileDetails(userinfo.username));
        }
    }, [dispatch]);



    useEffect(() => {
        if (inputRef.current) {
            const input = inputRef.current.input || inputRef.current;
            input.scrollLeft = input.scrollWidth;
        }
    }, [inputValue]);


    const handleBulkAudit = async () => {
        if (!auditType) {
            message.warning("Please select an Audit Type first");
            return;
        }
        if (!inputValue) {
            message.warning("Please enter AWB numbers");
            return;
        }
        if (auditType === "PINCODE" && !pincode) {
            message.warning("Please enter Pincode");
            return;
        }

        const currentAwbs = inputValue.split(",").map(item => item.trim()).filter(item => item !== "");

        if (currentAwbs.length === 0) {
            message.warning("Please enter at least one AWB number");
            return;
        }

        const userInfo = getUserAndPremiseId();
        const hubId = userInfo?.premiseId;
        const userId = userInfo?.userId;

        const payload = {
            auditType: auditType,
            awbNumbers: currentAwbs,
            ...(auditType === "PINCODE" && { pincode: parseInt(pincode) }),
            ...(auditType === "MODE" && { mode: selectedMode })
        };

        const headers = {
            "SMCS-PREMISE-ID": hubId,
            "USER-ID": userId
        };

        try {
            setLoading(true);
            const response = await NormalAPI.Api(urls.BULK_AUDIT_VALIDATE_AND_PROCESS).postCustomHeader(payload, headers);
            if (response.status) {
                const apiData = response?.response?.data;
                const successes = (apiData?.successfulAwbs || []).map(awb => ({
                    key: awb,
                    awbNumber: awb,
                    status: "Success",
                    message: "Audited Successfully"
                }));
                const failures = (apiData?.failures || []).map(fail => ({
                    key: fail.awbNumber || fail,
                    awbNumber: fail.awbNumber || fail,
                    status: "Failed",
                    message: fail.reason || "Audit Failed"
                }));

                const results = [...successes, ...failures];
                setAuditResults(results);

                if (apiData?.failureCount > 0) {
                    message.warning(`${apiData.successCount} succeeded, ${apiData.failureCount} failed`);
                } else {
                    message.success(apiData?.message || "Bulk Audit Successful");
                }
                setInputValue("");
            } else {
                message.error(response?.response?.data?.message || "Bulk Audit Failed");
            }
        } catch (error) {
            console.error("Bulk audit error:", error);
            message.error("Something went wrong during bulk audit");
        } finally {
            setLoading(false);
        }
    };

    const isFormInvalid = !auditType || !inputValue || (auditType === "PINCODE" && pincode?.length !== 6) || (auditType === "MODE" && !selectedMode);

    return (
        <Spin
            spinning={loading}
            indicator={
                <img src={Smcs_Loader} style={{ height: "100px", width: "100px" }} />
            }
        >
            <div className="master-main-container">
                <div
                    style={{ width: "95%", padding: "10px 10px 10px 3%" }}
                    className="global-form"
                >
                    <Form form={form} layout="vertical" initialValues={{ mode: "surface" }}>
                        <Row gutter={20} align="top">
                            <Col span={5}>
                                <DropDownComponent
                                    name="auditType"
                                    label="Select Audit Type"
                                    placeholder="Select Audit Type"
                                    options={auditOptions}
                                    style={{ width: "100%", height: "45px" }}
                                    className="indepentedInput"
                                    onChange={(value) => {
                                        setAuditType(value);
                                        if (value === "MODE" || value === "PINCODE") setSelectedMode("surface");
                                        setPincode("");
                                        setAuditResults([]);
                                    }}
                                    value={auditType}
                                    allowClear={false}
                                />
                            </Col>
                            {auditType === "MODE" && (
                                <Col span={5}>
                                    <DropDownComponent
                                        name="mode"
                                        label="Select Mode"
                                        placeholder="Select Mode"
                                        options={modeOptions}
                                        style={{ width: "100%", height: "45px" }}
                                        className="indepentedInput"
                                        onChange={(value) => setSelectedMode(value)}
                                        value={selectedMode}
                                        allowClear={false}
                                        initialValue="surface"
                                        disabled={true}
                                    />
                                </Col>
                            )}
                            {auditType === "PINCODE" && (
                                <Col span={5}>
                                    <Form.Item label="Enter Pincode">
                                        <Input
                                            className="indepentedInput"
                                            placeholder="Enter Pincode"
                                            type="number"
                                            value={pincode}
                                            style={{ height: "45px" }}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val.length <= 6) {
                                                    setPincode(val);
                                                }
                                            }}
                                            maxLength={6}
                                        />
                                    </Form.Item>
                                </Col>
                            )}
                            <Col span={auditType ? 10 : 15}>
                                <Form.Item
                                    label="Enter AWB number"
                                >
                                    <Input
                                        ref={inputRef}
                                        className="indepentedInput"
                                        placeholder="Enter AWB numbers (comma separated)"
                                        type="text"
                                        value={inputValue}
                                        style={{ height: "45px" }}
                                        onChange={(e) => {
                                            const val = e.target.value.replace(/[^a-zA-Z0-9, ]/g, "");
                                            setInputValue(val);
                                        }}
                                        onPaste={(e) => {
                                            e.preventDefault();
                                            const pastedData = e.clipboardData.getData("text");
                                            // Replace spaces, newlines, and tabs with commas
                                            const formatted = pastedData
                                                .replace(/[\s\n\t]+/g, ",") // Replace any whitespace with comma
                                                .replace(/,+/g, ",")        // Replace multiple commas with a single one
                                                .replace(/^,|,$/g, "");     // Trim leading/trailing commas

                                            const currentVal = inputValue ? (inputValue.endsWith(",") ? inputValue : inputValue + ",") : "";
                                            const newVal = (currentVal + formatted).replace(/,+/g, ",").replace(/^,|,$/g, "");
                                            const cleanedVal = newVal.replace(/[^a-zA-Z0-9,]/g, "");
                                            setInputValue(cleanedVal);
                                        }}

                                        allowClear
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={4} style={{ textAlign: "right" }}>
                                <Form.Item label=" ">
                                    <Button
                                        type="primary"
                                        className="global-button"
                                        style={{
                                            width: "150px",
                                            height: "45px",
                                            background: (loading || loader || isFormInvalid) ? "#ccc" : "#2e77d0",
                                            borderColor: (loading || loader || isFormInvalid) ? "#ccc" : "#2e77d0",
                                            color: "#fff",
                                            borderRadius: "5px",
                                            fontWeight: "bold"
                                        }}
                                        loading={loading}
                                        disabled={loading || loader || isFormInvalid}
                                        onClick={handleBulkAudit}
                                    >
                                        Bulk Audit
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    {auditResults.length > 0 && (
                        <Row style={{ marginTop: "20px" }}>
                            <Col span={24}>
                                <Table
                                    columns={[
                                        {
                                            title: "AWB Number",
                                            dataIndex: "awbNumber",
                                            key: "awbNumber",
                                            align: "center",
                                            render: (text) => (
                                                <a
                                                    style={{ color: "#2e77d0", fontWeight: "500", textDecoration: "underline" }}
                                                    onClick={() => window.open(`/shipment-tracker?awb=${text}`, "_blank")}
                                                >
                                                    {text}
                                                </a>
                                            )
                                        },
                                        {
                                            title: "Message",
                                            dataIndex: "message",
                                            key: "message",
                                            align: "center",
                                            render: (text, record) => (
                                                <span style={{ color: record.status === "Success" ? "#52c41a" : "#ff4d4f", fontWeight: "500" }}>
                                                    {text}
                                                </span>
                                            )
                                        }
                                    ]}
                                    dataSource={auditResults}
                                    pagination={{ pageSize: 5 }}
                                    size="small"
                                    className="global-table"
                                />
                            </Col>
                        </Row>
                    )}
                </div>
            </div>
        </Spin>
    );
};

export default BulkAudit;
